import { useEffect, useState } from 'react';

function useStorage(key, initialValue, storageObject, reviver) {
    const [value, setValue] = useState(() => {
        const savedValue = storageObject.getItem(key);
        if (savedValue) return JSON.parse(savedValue, reviver);
        if (typeof initialValue === 'function') return initialValue();
        else return initialValue;
    });

    useEffect(() => {
        storageObject.setItem(key, JSON.stringify(value));
    }, [value, key, storageObject]);
    return [value, setValue];
}

export function useLocalStorage(key, initialValue, reviver) {
    return useStorage(key, initialValue, window.localStorage, reviver);
}

export function useSessionStorage(key, initialValue, reviver) {
    return useStorage(key, initialValue, window.sessionStorage, reviver);
}
